import { AlertTriangle, LogIn } from 'lucide-react'
import { TestbedNotSignedInError } from '@/lib/testbed'

interface TestbedIdentityNoticeProps {
  error: unknown
}

/**
 * Shown in testbed mode in place of the Cloudflare Access warning (CAP-951). Nobody is signed in on
 * the testbed proxy: say so and link to its sign-in page. Anything else (proxy down, origin
 * refused) is reported as a testbed problem, never as an Access problem.
 */
export function TestbedIdentityNotice({ error }: TestbedIdentityNoticeProps) {
  if (error instanceof TestbedNotSignedInError) {
    return (
      <div role="status" className="border-b border-border bg-surface2 px-4 py-2">
        <div className="container mx-auto flex items-center gap-2">
          <LogIn className="h-4 w-4 shrink-0 text-textMuted" aria-hidden="true" />
          <p className="text-xs text-text">
            Sign in to the testbed to load data.{' '}
            <a
              href={error.signInUrl}
              className="font-medium underline underline-offset-2 hover:text-white/80"
            >
              Sign in
            </a>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div role="alert" className="border-b border-yellow-500/50 bg-yellow-500/10 px-4 py-2">
      <div className="container mx-auto flex items-center gap-2">
        <AlertTriangle
          className="h-4 w-4 shrink-0 text-yellow-600 dark:text-yellow-500"
          aria-hidden="true"
        />
        <p className="text-xs text-yellow-800 dark:text-yellow-200">
          {error instanceof Error ? error.message : 'Cannot reach the testbed proxy.'}
        </p>
      </div>
    </div>
  )
}
